import { render } from "./mp-qr.vue?vue&type=template&id=622facbb&scoped=true"
const script = {}

import "./mp-qr.vue?vue&type=style&index=0&id=622facbb&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622facbb"]])

export default __exports__